import { Map } from 'immutable';
import { AnyAction, Reducer } from 'redux';

import Budget from 'entities/budget/model';

import { ADD, ADD_MULTIPLE, REMOVE, UPDATE } from './constants';

export type BudgetState = Map<string, Budget>;
const initialState = Map<string, Budget>();

const budgetReducer: Reducer<BudgetState, AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    case ADD:
      return state.set(action.budget.id, action.budget);

    case ADD_MULTIPLE:
      return state.merge(action.budgets);

    case UPDATE:
      return state.set(action.budget.id, action.budget);

    case REMOVE:
      return state.delete(action.id);

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};

export default budgetReducer;
